export const IS_LOCAL = window.location.hostname === 'localhost';
export const IS_STAGE = window.location.hostname === 'osts-stg.infineon.com';

export const loadScript = (description: Record<string, string>) =>
  new Promise<void>(resolve => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.onload = () => resolve();

    if (description.code) {
      try {
        script.appendChild(document.createTextNode(description.code));
      } catch (e) {
        script.text = description.code;
      }
    } else {
      Object.keys(description).forEach(name => script.setAttribute(name, description[name]));
    }
    document.head.appendChild(script);
  });

const getOneTrustID = (): string =>
  !IS_STAGE ? '85f8227d-e015-4c62-ab96-ee1a08760fb3' : '85f8227d-e015-4c62-ab96-ee1a08760fb3-test';

const ONE_TRUST_ID = getOneTrustID();

export const oneTrustConsent = {
  src: `https://cdn.cookielaw.org/consent/${ONE_TRUST_ID}/OtAutoBlock.js`,
};
export const oneTrustTemplate = {
  'src': 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  'data-document-language': 'true',
  'charSet': 'UTF-8',
  'data-domain-script': ONE_TRUST_ID,
};
export const oneTrustStartScript = {
  code: 'function OptanonWrapper() { }',
};
